import { useState } from 'react';

import { useQueryActivitiesGraph } from 'api/queries/getActivitiesGraph.query';

export const useActivitiesGraphProvider = ({ latestVersionId }) => {
    const [filter, setFilter] = useState([2, 8]);
    const [showTasksConstraints, setShowTasksConstraints] = useState(false);
    const [showMilestones, setShowMilestones] = useState(false);

    return {
        ui: {
            state: {
                filter,
                showTasksConstraints,
                showMilestones,
            },
            setters: {
                setFilter,
                setShowTasksConstraints,
                setShowMilestones,
            },
        },
        api: {
            activitiesGraph: useQueryActivitiesGraph(getActivitiesGraphPayload({ latestVersionId, filter })),
        },
    };
};

const getActivitiesGraphPayload = ({ latestVersionId, filter }) => {
    return {
        id: latestVersionId ? String(latestVersionId) : '',
        maxLevel: filter[1],
        minLevel: filter[0],
    };
};
